package pages.home

import JQid
import kotlinx.browser.document
import kotlinx.browser.*
import kotlinx.html.style
import kotlinx.html.*
import kotlinx.html.js.header
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLEmbedElement
import pickAString



inline fun TagConsumer<HTMLElement>.bio()  = div("bio") {

style = """
   display: inline; 
   flex: 2.3;
   min-width: 335px;
"""

style {
   +"""
      @import url('https://fonts.googleapis.com/css2?family=Merriweather&display=swap');
           .bio {
             font-family: Merriweather;
             font-weight: bold;
             padding: 0.2em;
             margin: 0.2em;
             
           }
   """
}

   pDynamic ( "Hey, you. You're finally awake.", "At last - you've arrived.", "Hello, and welcome!", "Hi!", "Welcome!" )
   pDynamic ( "I am Alexander, a primate from Earth that can code & tinker.","I am Alexander, a primate from Earth that can code & tinker.", "I am Alexander - programmer and tinkerer.", "I am Alexander - I make stuff and break stuff.", "I am Alexander - welcome to my tiny corner of the internet. Please wipe your feet at the door." )
   pDynamic("I am very passionate about programming, music, running, and politics. I always love to learn and discuss new things. I'm a deep thinker and I love to problem-solve. ",
      "I am very passionate about technology, music, and learning. I like to run. I'm a deep thinker and enjoy solving problems. ")
   pDynamic(
      "I spend most of my days coding, as well as playing piano, running, or pondering reality. I'm a history geek; and I'm often studying random topics ranging from psychology, to poetry, to AI.",
      "I spend much time coding, playing music, or just pondering the existential nature of reality on a Sunday morning. I'm a good cook, but only if I'm cooking breakfast. I often find myself studying a broad range of topics - from mathematics, to military history, to economics.",
      "I spend a lot of my days coding, tinkering, playing piano, or reading the news. You might frequently catch me listening to podcasts on a broad range of topics, such as linguistics, philosophy, or history."
   )
   pDynamic(
      "I love music, and have hundreds of Spotify playlists!",
      "I love music, and have cultivated over 300 Spotify playlists throughout the years!",
      "I love music - and am a convicted audiophile. ",
      "I love leaning and applying music theory."
   )

   pDynamic(
      "I am also a huge fan of entropy, and the inevitable heat death of the universe!",
      "I'm also a huge fan of entropy and the eventual heat death of the universe!",
      "I am also a huge fan of entropy, and the inevitable decay of all existence!",
   )
   br();


}



fun TagConsumer<HTMLElement>.pDynamic(vararg strings :String) = p {
   val chosenParagraph = pickAString(strings.toList())
   div {


      button {
         style =

            "transform: scale(0.99, 0.79); position: absolute; right: -7px;" +
               "z-index: 9;" +
            "display: inline-block; padding: 0 2px; vertical-align: bottom; " +
            "border: 3px solid rgba(40,30,46,0.55); " +
            "border-radius: 1.17em; " +
            "box-shadow: .7px .7px 0 .9px rgba(0,0,0,0.2), 1.4px 1.4px 1.7px 2.7px rgba(0,0,0,0.05); " +
            "float: right; " +
            "margin-right: 1.9em;" +
            "cursor: pointer;"
         onMouseOver = "this.style.boxShadow='inset 1px 1px 0 1px rgba(0,0,0,0.19)'"
         onTouchStart = "this.style.boxShadow='inset 1px 1px 0 1px rgba(0,0,0,0.19)'"
         onMouseOut = "this.style.boxShadow='.7px .7px 0 .9px rgba(0,0,0,0.2), 1.4px 1.4px 1.7px 2.7px rgba(0,0,0,0.09)'"
         onTouchEnd = "this.style.boxShadow='.7px .7px 0 .9px rgba(0,0,0,0.2), 1.4px 1.4px 1.7px 2.7px rgba(0,0,0,0.09)'"

         onClickFunction = { ev->
            ev.target.asDynamic().parentNode.querySelector("p.pcontent").innerHTML = pickAString(strings.toList())

         }
         unsafe {
            +"""
         <svg style="pointer-events: none;" xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-recycle" width="27" height="26" viewBox="0 0 24 23" stroke-width="2.9" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
   <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
   <path d="M12 17l-2 2l2 2"></path>
   <path d="M10 19h9a2 2 0 0 0 1.75 -2.75l-.55 -1"></path>
   <path d="M8.536 11l-.732 -2.732l-2.732 .732"></path>
   <path d="M7.804 8.268l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024"></path>
   <path d="M15.464 11l2.732 .732l.732 -2.732"></path>
   <path d="M18.196 11.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976"></path>
</svg>      
""" }
      }
      p("pcontent") {
         +chosenParagraph
         style = "display: inline-block; float: left; pointer-events: none; font-size: 1.1em;" +
            "z-index: 4; margin: 0; margin-right: 2.35em;"
      }

      br{
         style = "clear: both;"
      }



   }
}







